import { useQuery } from "@jti/rest-api";

import { magento } from "../clients/getClient";
import type { OrderAttribute } from "../types";

type OrderAttributes = {
  orderAttributes: OrderAttribute[] | undefined;
  isOrderAttributesLoading: boolean;
};

export const useOrderAttributes = (): OrderAttributes => {
  const { data, isLoading } = useQuery("getOrderAttributes", async () => {
    const orderAttributes = await magento.getOrderAttributes();
    return orderAttributes;
  });
  return { orderAttributes: data, isOrderAttributesLoading: isLoading };
};
